import { Card, CardProps, Stack, StackProps, StyleProp } from "@mantine/core"

export function FormInputCardStack({
  children,
  maw,
  miw,
  childContainer,
  ...props
}: {
  maw?: StyleProp<React.CSSProperties["maxWidth"]>
  miw?: StyleProp<React.CSSProperties["maxWidth"]>
  childContainer?: StackProps
  children: React.ReactNode | React.ReactNode[]
} & CardProps) {
  return (
    <Card {...props}>
      <Stack gap="xs" maw={maw || 400} miw={miw} {...childContainer}>
        {children}
      </Stack>
    </Card>
  )
}
